import { palette } from "../palette"

export const MuiAutocomplete = {
  styleOverrides: {
    root: {
      backgroundColor: palette.background2,

      "&.Mui-focused": {
        backgroundColor: palette.background2,
      },
    },

    inputRoot: {
      backgroundColor: palette.background2,
      "&:hover": {
        backgroundColor: palette.background2,
      },
    },

    input: {
      backgroundColor: palette.background2,
      "&:hover": {
        backgroundColor: palette.inputs,
      },
    },

    inputFocused: {
      backgroundColor: palette.inputs,
    },

    groupLabel: {
      font: {
        size: "1.4rem",
        weight: 400,
      },
      paddingTop: 12,
    },

    groupUl: {
      borderBottom: [[1, "solid", "#efefef"]],
      borderTop: [[1, "solid", "#efefef"]],
    },

    hasClearIcon: {
      "& [class*='MuiAutocomplete-inputRoot']": {
        paddingRight: [6, "!important"],
      },
    },

    listbox: {
      "& li:last-child": {
        "& ul": { borderBottom: "none" },
      },
      "&.MuiAutocomplete-listbox": {
        "& .MuiAutocomplete-option": {
          borderTop: "1px solid #efefef",
          fontSize: "1.4rem",

          "&.Mui-focused": { backgroundColor: "#efefef" },
          "&:first-child": {
            borderTop: "none",
          },
          "&[aria-selected='true']": {
            "&.Mui-focused": { backgroundColor: "#efefef" },
            backgroundColor: "#efefef",
          },
        },
        maxHeight: 316,
        paddingTop: 0,
      },
      marginTop: 20,
    },

    paper: {
      "&.MuiAutocomplete-paper": {
        marginTop: 4,
      },
      fontSize: "1.4rem",
      padding: 0,
    },

    popper: {
      fontSize: "1.4rem",
    },
  },
}
